<div class="modal-header">
    <h4>New Work Order</h4>
</div>
<div class="modal-body">
    <div class="alert alert-danger" *ngIf="alert != null">
        {{alert}}
    </div>
    <div style="margin-bottom:10px;" *ngIf="AllowManualWorkOrderNumber">
        <label>Work Order</label><br />
        <input type="number" [(ngModel)]="formData.workOrder" class="form-control" style="max-width:300px;" (blur)="checkNumber()" required [ngClass]="{'is-invalid': workOrderInvalid || formData.workOrder == null || formData.workOrder === ''}" />
    </div>
    <div style="margin-bottom:10px;">
        <label>Lead Technician</label>
        <ng-select [(ngModel)]="formData.technician"
                   [items]="technicianList"
                   style="max-width:300px;"
                   (change)="technicianChanged()"
                   [required]="formData.technician == null || formData.technician === ''"
                   [searchable]="true"
                   bindLabel="UserFullName"
                   [searchFn]="searchFilter"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': formData.technician == null}">
        </ng-select>
    </div>
    <div style="margin-bottom:10px;">
        <label>Customer</label>
        <ng-select [(ngModel)]="formData.customer"
                   style="max-width:300px;"
                   [required]="formData.customer == null"
                   [ngClass]="{'is-invalid': formData.customer == null}"
                   (change)="customerChanged()"
                   [searchable]="true" (search)="nameCheck($event)"
                   [clearable]="false"
                   (open)="resetLookup()"
                   bindLabel="CustomerName"
                   bindValue="SMCustomerID"
                   [searchFn]="utilityService.noFilter"
                   [items]="customerList">
        </ng-select>
    </div>
    <div style="margin-bottom:10px;">
        <label>Service Site</label>
        <ng-select [(ngModel)]="formData.serviceSite"
                   *ngIf="!SMServiceSiteSuperLookup"
                   style="max-width:300px;"
                   theme="bootstrap4-1"
                   [required]="SMRequireSiteOnNewWO"
                   [ngClass]="{'is-invalid': SMRequireSiteOnNewWO && formData.serviceSite == null}"
                   (change)="siteChanged()"
                   [items]="siteList"
                   bindLabel="ServiceSiteName"
                   [searchable]="true">
        </ng-select>

        <ng-select [items]="siteList$ | async"
                   style="max-width:300px;"
                   bindLabel="ServiceSiteName"
                   [typeahead]="siteListInput$"
                    [ngClass]="{'is-invalid': SMRequireSiteOnNewWO && formData.serviceSite == null}"
                   [(ngModel)]="formData.serviceSite"
                   [required]="SMRequireSiteOnNewWO"
                   *ngIf="SMServiceSiteSuperLookup"
                   dropdownPosition="bottom">
        </ng-select>
    </div>
    <div style="margin-bottom:10px;">
        <label>Service Center</label>
        <ng-select [(ngModel)]="formData.serviceCenter" name="serviceCenter" style="max-width:300px;" required [searchable]="true" [clearable]="true" (change)="serviceCenterChanged()" [ngClass]="{'is-invalid': formData.serviceCenter == null}">
            <ng-option *ngFor="let data of centerList" [value]="data.ServiceCenter">{{data.ServiceCenterDescription}}</ng-option>
        </ng-select>
    </div>
    <div style="margin-bottom:10px;">
        <label>Division</label>
        <ng-select [(ngModel)]="formData.division" name="division" style="max-width:300px;" [searchable]="true" [clearable]="true">
            <ng-option *ngFor="let data of divisionList[formData.serviceCenter]" [value]="data.Division">{{data.Description}}</ng-option>
        </ng-select>
    </div>
    <div style="margin-bottom:10px;">
        <label>Call Type</label>
        <ng-select [(ngModel)]="formData.callType" name="callType" style="max-width:300px;" [required]="smDataService.SMCallTypeRequire" [searchable]="true" [clearable]="true" [ngClass]="{'is-invalid': smDataService.SMCallTypeRequire && formData.callType == null}">
            <ng-option *ngFor="let data of lookupList['SMCallType']" [value]="data.Code">{{data.CodeDescription}}</ng-option>
        </ng-select>
    </div>
    <div style="margin-bottom:10px;">
        <label>Work Order Description</label><br />
        <input type="text" [(ngModel)]="formData.description" class="form-control" style="max-width:300px;" required [ngClass]="{'is-invalid': formData.description == null || formData.description === ''}" />
    </div>
    <div style="margin-bottom:10px;">
        <label>Requested By</label><br />
        <input type="text" [(ngModel)]="formData.requestedBy" class="form-control" style="max-width:300px;" />
    </div>
    <div style="margin-bottom:10px;">
        <label>Requested By Phone</label><br />
        <input type="text" [(ngModel)]="formData.requestedByPhone" class="form-control" style="max-width:300px;" />
    </div>
    <div style="margin-bottom:10px;">
        <label>Site Contact</label><br />
        <input type="text" [(ngModel)]="formData.siteContact" class="form-control" style="max-width:300px;" />
    </div>
    <div style="margin-bottom:10px;">
        <label>Site Contact Phone</label><br />
        <input type="text" [(ngModel)]="formData.siteContactPhone" class="form-control" style="max-width:300px;" />
    </div>
    <div style="margin-bottom:10px;">
        <label>Notes</label>
        <textarea [(ngModel)]="formData.notes" class="form-control" appElastic rows="2" placeholder="Enter notes about your work here..."
                  style="font-size:14px;overflow-y: hidden;max-width:300px;"></textarea>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Close</button>
    <button type="button" class="btn btn-success" (click)="createNewWorkOrderClicked()"
            [disabled]="formData.description == null || formData.description === '' || formData.technician == null || formData.customer == null || formData.serviceCenter == null ||
                (SMRequireSiteOnNewWO && formData.serviceSite == null) || (AllowManualWorkOrderNumber && (workOrderInvalid || formData.workOrder == null || formData.workOrder === '')) ||
                (smDataService.SMCallTypeRequire && formData.callType == null)">
        Create
    </button>
</div>